import MicroModal from "micromodal"

document.addEventListener("DOMContentLoaded", () => {
    MicroModal.init()
})
